import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

export type OrganizationLicenseType = 'admin' | 'user';

export async function addOrganizationLicense(licenseType: OrganizationLicenseType) {
    const callable = httpsCallable(getFunctions(getApp(), 'us-central1'), 'addOrganizationLicense');
    const response = await callable({ licenseType });
    return response.data as { success: boolean; licenseType: OrganizationLicenseType; subscriptionId: string };
}

export function billingErrorMessage(error: any): string {
    const details = typeof error?.details === 'string'
        ? error.details
        : error?.details?.message || error?.details?.error?.detail;
    return String(details || error?.message || 'License purchase failed.').replace(/^Firebase:\s*/i, '');
}
